export { default } from './TotallySureCornerBanner'
